import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { useSubmitBookingMutation } from "../service/booking";
import { showError, showToast } from "../constants/toasts";
import Loader from "../constants/Loader";
import { Editor } from "draft-js";
import EditText from "../components/editText";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    selectedItem?: any;
    getBookingDetailsApi?: any;
}

export default function ServiceCompleted({ open, onClose, setOpen, selectedItem, getBookingDetailsApi }: ModalProps) {
    const [details, setDetails] = useState("");
    const [submitBooking, { isLoading }] = useSubmitBookingMutation();
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!details.trim()) {
            showError("Please enter completion details");
            return;
        }

        try {
            const response = await submitBooking({
                id: selectedItem,
                body: { submitDetails: details }
            }).unwrap();

            if (response.statusCode === 200) {
                showToast("Service completion submitted successfully");
                setOpen(false);
                setDetails("");
                if (getBookingDetailsApi) {
                    getBookingDetailsApi();
                }
            }
        } catch (error: any) {
            showError(error?.data?.message || "Failed to submit service completion");
        }
    };

    return (
        <Modal className="modal addReply_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <Loader isLoad={isLoading} />
                <div className="modal-body">
                    {/* Title Bar */}
                    <div className="modal_title">
                        <h2>Service Completion Details</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => {
                                setOpen(false);
                                setDetails("");
                            }}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Reply Section */}
                    <form className="form" onSubmit={handleSubmit}>
                        {/* <div className="control_group">

                            <TextField
                                placeholder="Enter details..."
                                fullWidth
                                hiddenLabel
                                multiline
                                minRows={4}
                                value={details}
                                onChange={(e) => setDetails(e.target.value)}
                            />
                        </div> */}
                        <div className="control_group">
                            <label id="add-details-label">Add details</label>
                            <div role="textbox" aria-labelledby="add-details-label">
                                <EditText content={details} setContent={setDetails} />
                            </div>
                        </div>
                        {/* Footer Buttons */}
                        <div className="footer_btn_flex">
                            <Button type="submit" className="btn btn_primary" disabled={isLoading}>
                                Send
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
